(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerController', CompanyCustomerController);

    CompanyCustomerController.$inject = ['$scope', '$state', 'CompanyCustomer', 'CompanyCustomerSearch', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CompanyCustomerCustom', '$mdDialog', '$translatePartialLoader'];

    function CompanyCustomerController($scope, $state, CompanyCustomer, CompanyCustomerSearch, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CompanyCustomerCustom, $mdDialog, $translatePartialLoader) {

        var vm = this;
        vm.companyCustomer = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.getCompanyCustomerFormDataFunc = getCompanyCustomerFormDataFunc;
        vm.editCompanyCustomerFormDataFunc = editCompanyCustomerFormDataFunc;
        vm.hasAllNecessaryFields = false;
        vm.customerFormData = null;
        vm.columnCount = null;

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');

            // if (vm.companyCustomer && vm.companyCustomer.id) {
            //     // vm.companyCustomer.forms = CompanyCustomerCustom.getCompanyCustomForm(vm.companyCustomer.companyId).query();
            //     CompanyCustomerCustom.getCompanyCustomFormDataByCompanyCustomerId(vm.companyCustomer.id).query(function (res) {
            //
            //         vm.companyCustomer.formsData = res;
            //         console.log(vm.companyCustomer);
            //
            //         vm.companyCustomer.formsData.sort(function (a, b) { //to sort by id desc
            //             return b.id - a.id;
            //         });
            //         console.log(vm.companyCustomer.formsData);
            //     });
            // }
        }

        function getCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle) {

            CompanyCustomerCustom.getNewCompanyCustomerFormData(companyCustomFormId).query(function (res) {

                vm.customerFormData = res;
                vm.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
                vm.customerFormData.companyCustomer = vm.companyCustomer;
                openEditDataDialog(vm.customerFormData);

            });
        }

        // function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {
        function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {

            vm.customerFormData = data;
            vm.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
            vm.customerFormData.companyCustomer = vm.companyCustomer;
            openEditDataDialog(vm.customerFormData);
        }

        // function openEditDataDialog(customerFormData) {
        //     vm.columnCount = 4 ;
        //     $mdDialog.show({
        //         locals: {dialogData: customerFormData , columnCount: vm.columnCount},
        //         controller: ComponentIntakeDataDialogController,
        //         templateUrl: 'app/components/eyeson/intake-data-component/component-intake-data-dialog.html',
        //         controllerAs: '$ctrl',
        //         parent: angular.element(document.body),
        //         targetEvent: customerFormData,
        //         clickOutsideToClose: true
        //     })
        //         .then(function (answer) {
        //             $scope.status = 'You said the information was "' + answer + '".';
        //         }, function () {
        //             $scope.status = 'You cancelled the dialog.';
        //         });
        // };

        function save() {
            vm.isSaving = true;

            if (vm.companyCustomer.id !== null) {
                CompanyCustomerCustom.updateCompanyCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
            } else {
                if (vm.companyCustomer.customer !== null) {
                    CompanyCustomerCustom.addNewCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
                }

            }


            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:companyCustomerUpdate', result);
                // vm.companyCustomer = result;

                //  if($state.current.url.includes('new'))
                $state.go('company-customer.edit', {id: result.id});

                loadAll();

                // CustomerCustom.saveScheduleList().update(vm.serviceList, function () {
                //     $scope.$emit('tikonApp:customerUpdate', result);
                //     vm.serviceList = CompanyCustomer.serviceItemScheduleByCustomerId(customer.id).query(function (result) {
                //         vm.companyCustomer.customer = result;
                //     });
                //     vm.isSaving = false;
                // })


            }

        }
    }
})();
